module.exports = __webpack_public_path__ + "img/rewards.26745cf4.png";